import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import moment from 'moment';

const useSchedule = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [scheduleList, setScheduleList] = useState<ScheduleListDto[]>([]);
  const [lectureSummerList, setLectureSummerList] = useState<LecturerSummeryDto[]>([]);
  const [lecturerTotal, setLecturerTotal] = useState<LecturerTotalDto>();
  const [weekList, setWeekList] = useState<MonthWeekDto[]>([]);

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.schedule.list, location.search],
    () =>
      fetcher.schedule.postScheduleList({
        searchValue: searchParams.search ? String(searchParams.search) : '',  
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : moment().format('YYYY-MM-DD').toString(),   
        biz: searchParams.biz ? String(searchParams.biz) : '',  
        pm: searchParams.pm ? String(searchParams.pm) : '',  
        cm: searchParams.cm ? String(searchParams.cm) : '',  
        target: searchParams.target ? String(searchParams.target) : '',  
        lecturer: searchParams.lecturer ? String(searchParams.lecturer) : '',  
        status: searchParams.status ? String(searchParams.status) : '',  
        lecture_type: searchParams.lecture_type ? String(searchParams.lecture_type) : '',  
        lecture_subject: searchParams.lecture_subject ? String(searchParams.lecture_subject) : '',  
      }),
    {
      onSuccess: (res: ScheduleListResDto) => {
        switch (res.code) {
          case 200:
            setScheduleList(res.result?res.result.list:[]);
            setLectureSummerList(res.result?res.result.lecturer_list:[]);
            setLecturerTotal(res.result?.lecturer_total);
            setWeekList(res.result?res.result.week_list:[]);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { scheduleList, lectureSummerList, lecturerTotal, weekList, refetch };
};

export default useSchedule;
